import { useMemo, useState } from "react";
import { axiosGetWithHeader } from "../../Common/axios";
import { handleClickColor } from "../../Common/Util";
import Spinner from 'react-bootstrap/Spinner';

export function KPEffectiveSignificator ({userData}) {
  const [chartData, setChartData] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Effective Significators');

  useMemo(() => {
    if(userData===null||userData===undefined) {
      setSpinner(null);
      return;
    }
    var clientId = userData.id;
    axiosGetWithHeader("/chart/effectiveplanetsignificator/"+clientId,
      (response)=>{
        setChartData(response.data);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setChartData([]);
        setSpinner(null);
      }
    );
  }, [userData]);

  const tdwidth = {
    width: "25%",
  };

    return(
      <>
        {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
        {  
          chartData===null||chartData.length===0?(
            <></>
          ):(
          <>
        <table class="table table-bordered table-hover align-middle caption-top m-0 p-0 text-center TableFont">
          <caption class="m-0 p-0" ><h5 class="m-0 p-2">Effective Significators</h5></caption>
          <thead>
            <tr class="p-0 m-0">
              <th class="m-0 p-1 kptable-td">Planet (A)</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>Sub Lord (B)</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>Signification of A</th> 
              <th class="m-0 p-1 kptable-td" style={tdwidth}>Signification of B</th> 
            </tr>
          </thead>
          <tbody>
            {chartData.map((planet) => (
                  <tr class="p-0 m-0"  onClick={handleClickColor}>
                      <th class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[0]}</th>
                      <td class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[1]}</td>
                      <td class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[2]}</td>
                      <td class="bg-transparent text-start p-0 ps-1 kptable-td">{planet[3]}</td>
                  </tr>
              ))}
          </tbody>  
          </table>
          </>
          )
        }
        </>
      );
  }